export const getSchedulesForMonthAndDay = (schedule, month, day) => schedule[`${month}/${day}`] || [];
